import PostComments from "./PostComments";

export default PostComments